import axios from 'axios'
import store from '@/store'
import { showToast } from '@/utils/common'
import { Toast } from "vant";
import router from '@/router'
// import { getQueryString  } from '@/utils/common'

Toast.allowMultiple(true) // 开启toast允许多例

let ajaxSum = 0 // 记录正在进行中ajax总数量
let loadingInstance // 记录loading实例
const errMsg = Toast // 错误弹框实例
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 15000 // request timeout 
  // timeout: 150 // request timeout 
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    ajaxSum += 1 // ajax数量加一
    if (!loadingInstance && !config.hideLoading) {
      // 是否需要隐藏loading， 默认开启，
      loadingInstance = Toast.loading({
        // 记录loading配置，返回loading实例
        duration: 0,
        message: config.loadingMessage || '加载中...',
        forbidClick: true,
        loadingType: 'spinner'
      })
    }
    if (config.url.startsWith('http')) {
      config.baseURL = '';
    }
    // console.log(config);
    //  console.log(store.state);
    // 不同的接口控制器，使用不同的token作为登录凭证
    let { url } = config
    // let { bankToken, heavyCustomerToken, businessToken, referenceToken, userToken } = store.state

    //若接口传入token，则将token设置到请求头
    if (config.token) {
      config.headers['Authorization'] = config.token;
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */
  (response) => {
    // console.log(response, 'response=======');
    let res = response.data
    ajaxSum -= 1 // 进行中ajax数量减一
    const dsq = setTimeout(() => {
      // 过一段时间后判断判断是否还有进行中的请求，若没有则关闭loading并清除定时器
      if (ajaxSum === 0) {
        loadingInstance && loadingInstance.clear() // 关闭Loading
        loadingInstance = null
        clearTimeout(dsq)
      }
    }, 300)
    if (res.code === 5030) {
      // 数据库存链接异常
      return window.location.replace(
        'https://mapa.quancangyun.cn/ydsh-ph-smart-code/#/system/upgrade'
      )
    }
    if (response.config.custom) {
      //接口传入custom，直接返回类
      return res
    } else {
      if (res.code === 0) {
        return res
      } else if (res.code === 403 || res.code === 401) {
        errMsg.fail('登录已过期，请退出重试')

        store.commit('signOut')
        // location.reload()

      } else {
        // if(!response.config.hideErrMsgToast) errMsg.fail(res.message || 'Error')
        if (!response.config.hideErrMsgToast) showToast(res.message || 'Error')
        return Promise.reject(res || 'Error')
      }
    }
  },
  error => {
    ajaxSum -= 1 // 进行中ajax数量减一
    const dsq = setTimeout(() => {
      // 过一段时间后判断判断是否还有进行中的请求，若没有则关闭loading并清除定时器
      clearTimeout(dsq)
      if (ajaxSum === 0) {
        loadingInstance && loadingInstance.clear() // 关闭Loading
        loadingInstance = null
      }
    }, 300)
    // errMsg.fail(error.message)
    errMsg.fail('服务器异常，请稍后重试')
    return Promise.reject(error)
    // return error 
  }
)

export default service